import React from 'react';
import { PRIORITIES, LOCATION_TYPES } from '../constants';
import LocationSection from './LocationSection';

const RequestDetailsSection = ({ 
  formData,
  documentTypes,
  isLoadingDocumentTypes,
  locations,
  isLoadingLocations,
  isSubmitting, 
  handleChange 
}) => {
  return (
    <>
      <div className="col-span-full mt-4">
        <h3 className="text-black font-semibold mb-4 font-poppins text-lg">
          Request Details
        </h3>
      </div>

      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
          Priority <span className="text-red-500">*</span>
        </label>
        <select
          name="priority"
          value={formData.priority}
          onChange={handleChange}
          disabled={isSubmitting}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
        >
          <option value="">Select Priority</option>
          {PRIORITIES.map((priority) => (
            <option key={priority.value} value={priority.value}>
              {priority.label}
            </option>
          ))}
        </select>
      </div>

      <div className="relative">
        <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
          Location <span className="text-red-500">*</span>
        </label>
        <select
          name="locationType"
          value={formData.locationType}
          onChange={handleChange}
          disabled={isSubmitting}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
        >
          <option value="">Select Location Type</option>
          {LOCATION_TYPES.map((location) => (
            <option key={location.value} value={location.value}>
              {location.label}
            </option>
          ))}
        </select>
      </div>

      {/* Location Section */}
      <LocationSection
        formData={formData}
        locations={locations}
        isLoadingLocations={isLoadingLocations}
        isSubmitting={isSubmitting}
        handleChange={handleChange}
      />

      {/* Document Type Selection */}
      <div className="col-span-full">
        <label className="block text-sm font-medium text-gray-700 mb-2 font-poppins">
          Document Type <span className="text-red-500">*</span>
        </label>
        <select
          name="documentType"
          value={formData.documentType}
          onChange={handleChange}
          disabled={isSubmitting || isLoadingDocumentTypes}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-poppins"
        >
          <option value="">Select Document Type</option>
          {documentTypes && documentTypes.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </select>
        {isLoadingDocumentTypes && (
          <div className="flex items-center mt-2">
            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600 mr-2"></div>
            <span className="text-sm text-gray-600 font-poppins">Loading document types...</span>
          </div>
        )}
      </div>
    </>
  );
};

export default RequestDetailsSection; 